import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DpDatePickerModule, IDatePickerConfig, ISelectionEvent} from "ng2-date-picker";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {Period} from "../../../models/Misc/Period";
import dayjs from 'dayjs';
import {LanguageService} from "../../../services/language.service";
import 'dayjs/locale/fr';
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";

@Component({
  selector: 'synapi-datepickers',
  standalone: true,
  imports: [
    DpDatePickerModule,
    FormsModule,
    CommonModule
  ],
  templateUrl: './synapi-datepickers.component.html',
  styleUrl: './synapi-datepickers.component.scss',
  host: {ngSkipHydration: 'true'}
})


export class SynapiDatepickersComponent implements OnInit,OnChanges{
  @Input() selection?: string;
  @Output() onPeriodChange = new EventEmitter<Period>()
  show = false;
  init = false;
  showAll = false;
  showToday = false;
  showTomorrow = false;
  showWeekEnd = false;
  showWeek = false;
  showMonth = false;
  activeAll = false;
  activeToday = false;
  activeTomorrow = false;
  activeWeekEnd = false;
  activeWeek = false;
  activeMonth = false;
  showCustom = false;
  date: {today:Date,today_7:Date,tomorrow:Date,sunday:Date,saturday:Date,month:Date, year:Date}
  @Input() start?: Date;
  @Input() end?: Date;
  datepickerStart: string = "";
  datepickerEnd: string = "";
  datePickerConfig : IDatePickerConfig = {
    firstDayOfWeek : "mo",
    format: "DD/MM/YYYY"
  }
  constructor(public lang : LanguageService) {
    this.date = {
      today : new Date(),
      today_7 :  new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000),
      tomorrow :  new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
      sunday : this.getNextDayOfWeek(new Date(),6),
      saturday : this.getNextDayOfWeek(new Date(),0),
      month : new Date(new Date().getTime() + 31 * 24 * 60 * 60 * 1000),
      year : new Date(new Date().getTime() + 12 * 31 * 24 * 60 * 60 * 1000),
    };
    dayjs.locale(lang.current);
    this.init = true;
  }

  initSelectors(){
    if(this.selection){
      this.show = ['50851','99974','99973','99970','56330','111392','99971','54855','53993','53992','54016','54992','168164'].indexOf(this.selection) != -1 || this.selection.includes('evenement');
      this.showToday = ['50851','99974','99973','99970','56330','111392','99971','54855','53993','53992','54016','54992','168164'].indexOf(this.selection) != -1
      this.showTomorrow = ['50851','99974','99973','99970','56330','111392','99971','54855','53993','53992','54016','54992','168164'].indexOf(this.selection) != -1
      this.showWeekEnd = ['50851','99971','56330','111392','54855','53993','53992','54016','54992','168164'].indexOf(this.selection) != -1
      this.showWeek = ['50851','99974','99973','56330','111392','54855','53993','53992','54016','54992','168164'].indexOf(this.selection) != -1
      this.showMonth = ['50851','99974','56330','111392','54855','53993','53992','54016','54992','168164'].indexOf(this.selection) != -1
      this.showAll = ['50851','99974','99973','99970','56330','111392','99971','54855','53993','53992','54016','54992','168164'].indexOf(this.selection) != -1 || this.selection.includes('evenement');
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['selection'].currentValue != changes['selection'].previousValue ){
      this.initSelectors();
    }
  }

  ngOnInit(){
    this.initSelectors();
    if(this.selection && this.show){
      this.activeAll = true;
      if(this.start && this.end){
        this.initActiveByDates(new Date(this.start),new Date(this.end));
      }
      this.start = this.start ? new Date(this.start) : this.date.today;
      this.end = this.end ? new Date(this.end) : this.date.year;

      this.onPeriodChange.emit(new Period(this.start,this.end));
    }
    if (this.selection?.indexOf('evenements') !== -1 && this.selection?.indexOf('evenements.periodes') === -1) {
      this.initActiveByDates(this.date.today, this.date.year);
    }
  }

  getNextDayOfWeek(date:Date, dayOfWeek:number) {
    const resultDate = new Date(date.getTime());
    resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);
    return resultDate;
  };

  cleanActive(){
    this.activeAll = false;
    this.activeToday = false;
    this.activeTomorrow = false;
    this.activeWeek = false;
    this.activeWeekEnd = false;
    this.activeMonth = false;
  }

  initActiveByDates(start:Date, end:Date){
    this.cleanActive();
    const nstart = start.toLocaleDateString('en-CA');
    const nend = end.toLocaleDateString('en-CA');
    if(nstart == this.date.today.toLocaleDateString('en-CA') && nend == this.date.year.toLocaleDateString('en-CA')) this.activeAll = true;
    if(nstart == this.date.today.toLocaleDateString('en-CA') && nend ==this.date.today.toLocaleDateString('en-CA')) this.activeToday = true;
    if(nstart == this.date.tomorrow.toLocaleDateString('en-CA') && nend ==this.date.tomorrow.toLocaleDateString('en-CA')) this.activeTomorrow = true;
    if(nstart == this.date.sunday.toLocaleDateString('en-CA') && nend ==this.date.saturday.toLocaleDateString('en-CA')) this.activeWeekEnd = true;
    if(nstart == this.date.today.toLocaleDateString('en-CA') && nend ==this.date.saturday.toLocaleDateString('en-CA')) this.activeWeek = true;
    if(nstart == this.date.today.toLocaleDateString('en-CA') && nend ==this.date.month.toLocaleDateString('en-CA')) this.activeMonth = true;
  }

  onClickDates(start:Date, end:Date){
    this.showCustom = false;
    this.cleanActive();
    this.datepickerStart = "";
    this.datepickerEnd = "";
    this.start = start;
    this.end = end;
    this.onPeriodChange.emit(new Period(this.start,this.end));
  }

  onCustomClick(){
    this.showCustom = !this.showCustom;
  }

  onSelectStartDate($event:ISelectionEvent){
    this.cleanActive();
    this.start = new Date($event.date.toString());
    console.log(this.start);
    if(this.end)
    this.onPeriodChange.emit(new Period(this.start,this.end));
  }

  onSelectEndDate($event:ISelectionEvent){
    this.cleanActive();
    this.end = new Date($event.date.toString());
    if(this.start)
    this.onPeriodChange.emit(new Period(this.start,this.end));
  }

  reset(){
    if(this.show){
      this.onClickDates(this.date.today, this.date.year);
      this.initActiveByDates(this.date.today, this.date.year);
    }
  }

}
